import { render } from "./builder.vue?vue&type=template&id=40149e32"
import script from "./builder.vue?vue&type=script&lang=js"
export * from "./builder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__